import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const TaskModal = ({ isOpen, onClose, onSave, initialData }) => {
  const [taskData, setTaskData] = useState({
    date: '',
    day: '',
    workHours: '',
    mealHours: '',
    taskDescription: '',
  });

  useEffect(() => {
    if (initialData) {
      setTaskData(initialData);
    } else {
      setTaskData({
        date: '',
        day: '',
        workHours: '',
        mealHours: '',
        taskDescription: '',
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaskData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(taskData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 overflow-auto">
      <SEO
        title="Task Manager"
        description="Create and manage tasks for your film production project on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/tasks"
        robots="noindex, nofollow"
      />
      <div className="bg-white p-4 rounded-lg shadow-lg max-w-md w-full h-fit">
        <h2 className="text-lg font-bold mb-4">{initialData ? 'Edit Task' : 'Add Task'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-1">Date:</label>
            <input
              type="date"
              name="date"
              value={taskData.date}
              onChange={handleChange}
              className="border px-3 py-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Day:</label>
            <input
              type="text"
              name="day"
              value={taskData.day}
              onChange={handleChange}
              className="border px-3 py-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Work Hours:</label>
            <input
              type="text"
              name="workHours"
              value={taskData.workHours}
              onChange={handleChange}
              className="border px-3 py-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Meal Hours:</label>
            <input
              type="text"
              name="mealHours"
              value={taskData.mealHours}
              onChange={handleChange}
              className="border px-3 py-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Task Description:</label>
            <textarea
              name="taskDescription"
              value={taskData.taskDescription}
              onChange={handleChange}
              className="border px-3 py-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Upload file:</label>
            <input 
              type="file" 
              name="file" 
               // You will need a function to handle file selection
            />
          </div>
         
          <div className="flex justify-between">
            <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded-lg">
              Cancel
            </button>
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-lg">
              {initialData ? 'Update Task' : 'Add Task'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaskModal;

